import { BOSS_MECHANICS } from '@/config/boss-mechanics';

/**
 * A damage gate held up by the boss's OWN summons (reinforcement elites,
 * Hive flies, Admiral escorts). It drops when the summons are gone — or,
 * as a stall failsafe, after `summonGateFailsafe` seconds (a summon stuck
 * behind rocks must never lock the boss forever).
 */
export class SummonGate {
  locked = false;
  private held = 0;

  /** Summons just deployed — the gate goes up. */
  raise(): void {
    this.locked = true;
    this.held = 0;
  }

  /** @returns true on the step the gate drops */
  update(dt: number, summonsAlive: number): boolean {
    if (!this.locked) return false;
    this.held += dt;
    if (summonsAlive > 0 && this.held < BOSS_MECHANICS.summonGateFailsafe) return false;
    this.locked = false;
    return true;
  }
}
